<template>
  <div class="wa-chat-window">
    <!-- Active Conversation -->
    <template v-if="chatSeleccionado">
      <!-- Chat Header -->
      <div class="wa-chat-header">
        <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
          <!-- Mobile Menu Button -->
          <button class="btn wa-icon-btn d-lg-none me-2 text-white p-0" @click="$emit('abrir-sidebar')"
            title="Ver lista de chats">
            <i class="mdi mdi-menu font-size-24"></i>
          </button>

          <!-- Avatar + Nombre -->
          <div class="d-flex align-items-center flex-grow-1 overflow-hidden cursor-pointer me-2"
            @click="$emit('toggle-panel-info')" title="Ver info del contacto">
            <div class="me-3 flex-shrink-0">
              <CmpDualAvatar :avatar-cliente="chatSeleccionado.avatarCliente || null"
                :id-cliente="obtenerIdCliente(chatSeleccionado)"
                :avatar-whatsapp="chatSeleccionado.avatarWhatsapp || null" :nombre="nombreContacto(chatSeleccionado)"
                :inicial="inicialContacto(chatSeleccionado)" :es-varios="esClienteGenerico(chatSeleccionado)" />
            </div>

            <div class="overflow-hidden">
              <h6 class="wa-active-contact-name text-truncate mb-0">
                {{ nombreContacto(chatSeleccionado) }}
                <span v-if="!esClienteGenerico(chatSeleccionado) && chatSeleccionado.numero"
                  class="text-white-50 font-size-12 fw-normal ms-2">
                  ({{ chatSeleccionado.prefijo ? chatSeleccionado.prefijo + ' ' : '' }}{{ chatSeleccionado.numero }})
                </span>
                <span v-if="chatSeleccionado.principal"
                  class="badge bg-warning text-dark font-size-10 ms-1">Principal</span>
                <span v-if="estaBloqueado"
                  class="badge bg-danger text-white font-size-10 ms-1"><i class="mdi mdi-block-helper me-1"></i>Bloqueado</span>
              </h6>
            </div>
          </div>
        </div>

        <!-- Header Actions -->
        <div class="wa-header-actions d-flex align-items-center">
          <div class="dropdown d-inline-block">
            <button class="btn wa-icon-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false"
              title="Más opciones">
              <i class="mdi mdi-dots-vertical"></i>
            </button>
            <ul class="dropdown-menu dropdown-menu-end shadow-sm">
              <li>
                <a class="dropdown-item font-size-13" href="javascript:void(0);"
                  :class="{ 'disabled text-muted': enviandoPlantillaInicio || cargandoMensajes }"
                  @click="$emit('inicializar-conversacion', chatSeleccionado)">
                  <i class="mdi me-2 text-success font-size-16"
                    :class="enviandoPlantillaInicio ? 'mdi-loading mdi-spin' : 'mdi-send-check-outline'"></i>
                  {{ enviandoPlantillaInicio ? 'Enviando plantilla...' : 'Iniciar conversación' }}
                </a>
              </li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li><a class="dropdown-item font-size-13" href="javascript:void(0);" @click="$emit('abrir-panel-info')"><i
                    class="mdi mdi-information-outline text-success me-2"></i>Info. del contacto</a></li>
              <li><a class="dropdown-item font-size-13" href="javascript:void(0);"
                  @click="$emit('abrir-modal-asignar-cliente', chatSeleccionado)"><i
                    class="mdi mdi-account-arrow-right text-success me-2"></i>{{ esClienteGenerico(chatSeleccionado) ?
                      'Asignar cliente' : 'Cambiar cliente' }}</a></li>
              <li v-if="!esClienteGenerico(chatSeleccionado) && obtenerIdCliente(chatSeleccionado)">
                <router-link
                  :to="{ name: 'tableroCliente', params: { id_cliente: obtenerIdCliente(chatSeleccionado) } }"
                  target="_blank" class="dropdown-item font-size-13">
                  <i class="mdi mdi-account-box-outline text-primary me-2"></i>Ver tablero del cliente
                </router-link>
              </li>
              <li><a class="dropdown-item font-size-13 text-secondary" href="javascript:void(0);"
                  @click="$emit('vaciar-chat', chatSeleccionado)"><i class="mdi mdi-broom me-2 text-warning"></i>Vaciar
                  chat</a></li>
              <li>
                <hr class="dropdown-divider">
              </li>
              <li v-if="!estaBloqueado">
                <a class="dropdown-item font-size-13 text-danger" :class="{ 'disabled text-muted': procesandoBloqueo }" href="javascript:void(0);"
                  @click="accionBloquear(chatSeleccionado)">
                  <i class="mdi me-2" :class="procesandoBloqueo ? 'mdi-loading mdi-spin' : 'mdi-block-helper'"></i>Bloquear número
                </a>
              </li>
              <li v-else>
                <a class="dropdown-item font-size-13 text-success" :class="{ 'disabled text-muted': procesandoBloqueo }" href="javascript:void(0);"
                  @click="accionDesbloquear(chatSeleccionado)">
                  <i class="mdi me-2" :class="procesandoBloqueo ? 'mdi-loading mdi-spin' : 'mdi-lock-open-outline'"></i>Desbloquear número
                </a>
              </li>
              <li><a class="dropdown-item font-size-13 text-danger" href="javascript:void(0);"
                  @click="$emit('eliminar-chat', chatSeleccionado)"><i
                    class="mdi mdi-chat-remove-outline me-2"></i>Eliminar chat</a></li>
              <li><a class="dropdown-item font-size-13 text-danger" href="javascript:void(0);"
                  @click="$emit('eliminar-telefono-cliente', chatSeleccionado)"><i
                    class="mdi mdi-phone-remove-outline me-2"></i>Eliminar número de teléfono</a></li>
            </ul>
          </div>
          <button v-if="!panelInfoVisible" class="btn wa-icon-btn" @click="$emit('cerrar-chat')" title="Cerrar chat">
            <i class="mdi mdi-close font-size-18"></i>
          </button>
        </div>
      </div>

      <!-- Chat Messages Wallpaper & Stream -->
      <SimpleBar ref="conversationScroll" class="wa-conversation-scroll" data-simplebar @scroll="onScrollConversacion">
        <div class="wa-messages-container">
          <!-- Spinner cargando lote anterior de mensajes -->
          <div v-if="cargandoMasMensajes" class="text-center py-2">
            <div class="spinner-border text-success spinner-border-sm me-1" role="status"></div>
            <span class="text-muted font-size-12">Cargando mensajes anteriores...</span>
          </div>

          <!-- Spinner de carga inicial -->
          <div v-if="cargandoMensajes && listaMensajes.length === 0" class="text-center py-5">
            <div class="spinner-border text-success spinner-border-sm me-2" role="status"></div>
            <span class="text-muted font-size-13">Cargando mensajes...</span>
          </div>

          <!-- Mensaje vacío si no hay mensajes con opción para enviar plantilla de inicio -->
          <div v-else-if="listaMensajes.length === 0"
            class="text-center py-5 d-flex flex-column align-items-center justify-content-center">
            <div class="wa-init-chat-card p-4 rounded-3 text-center">
              <div class="wa-init-chat-icon mb-2">
                <i class="mdi mdi-message-text-fast-outline text-success" style="font-size: 42px;"></i>
              </div>
              <h6 class="fw-semibold mb-1 wa-init-chat-title font-size-15">No hay mensajes en esta conversación</h6>
              <p class="text-muted font-size-12 mb-3" style="max-width: 320px; line-height: 1.45;">
                Para iniciar la conversación con este contacto, envía la plantilla oficial de inicio de conversación.
              </p>
              <button type="button"
                class="btn btn-success btn-sm px-3 py-2 d-inline-flex align-items-center justify-content-center shadow-sm"
                :disabled="enviandoPlantillaInicio || cargandoMensajes"
                @click="$emit('inicializar-conversacion', chatSeleccionado)">
                <i class="mdi me-1 font-size-16"
                  :class="enviandoPlantillaInicio ? 'mdi-loading mdi-spin' : 'mdi-send-check-outline'"></i>
                <span>{{ enviandoPlantillaInicio ? 'Enviando plantilla...' : 'Iniciar conversación' }}</span>
              </button>
            </div>
          </div>

          <!-- Listado de mensajes -->
          <template v-else>
            <div v-for="(msg, idx) in listaMensajes" :key="msg.id || msg.wamid || idx"
            :data-msg-id="obtenerKeyMensajeId(msg)" class="wa-message-group">
            <!-- Dynamic Date Divider Badge -->
            <div v-if="mostrarSeparadorFecha(msg, idx, listaMensajes)" class="wa-date-divider">
              <span class="wa-date-pill">{{ obtenerEtiquetaFecha(msg) }}</span>
            </div>

            <!-- Message Bubbles (Saliente a la derecha, Entrante a la izquierda) -->
            <div class="wa-message-row" :class="[
              esSaliente(msg) ? 'wa-msg-out' : 'wa-msg-in',
              { 'wa-has-reaction': obtenerReaccion(msg) }
            ]">
              <button type="button" class="wa-bubble-action-btn" @click.stop="iniciarRespuesta(msg)"
                title="Responder a este mensaje">
                <i class="mdi mdi-reply font-size-15"></i>
              </button>
              <div class="wa-bubble" :class="{
                'wa-bubble-media': esMensajeMedia(msg),
                'wa-bubble-sticker': obtenerTipoMensaje(msg) === 'sticker',
                'wa-bubble-emoji-1': obtenerConteoEmojis(msg) === 1,
                'wa-bubble-emoji-2': obtenerConteoEmojis(msg) === 2,
                'wa-bubble-emoji-3': obtenerConteoEmojis(msg) === 3
              }" @dblclick="iniciarRespuesta(msg)">
                <!-- Quoted / Reply Box -->
                <div v-if="obtenerMensajeCitado(msg)" class="wa-quoted-box"
                  :class="{ 'wa-quoted-outgoing': esSalienteCitado(msg) }"
                  @click="scrollAlMensaje(obtenerMensajeCitado(msg))">
                  <div class="wa-quoted-bar"></div>
                  <div class="wa-quoted-body">
                    <div class="wa-quoted-author">{{ obtenerAutorCitado(msg) }}</div>
                    <div class="wa-quoted-text text-truncate">
                      <i v-if="obtenerIconoCitado(msg)" :class="obtenerIconoCitado(msg)" class="me-1"></i>
                      {{ obtenerTextoCitado(msg) }}
                    </div>
                  </div>
                  <div v-if="obtenerThumbCitado(msg)" class="wa-quoted-thumb">
                    <img :src="obtenerThumbCitado(msg)" alt="thumbnail" />
                  </div>
                </div>

                <!-- STICKER -->
                <div v-if="obtenerTipoMensaje(msg) === 'sticker'" class="wa-sticker-container">
                  <img v-if="obtenerMediaUrl(msg, 'sticker')" :src="obtenerMediaUrl(msg, 'sticker')" alt="Sticker"
                    class="cursor-pointer" @click="abrirLightbox(obtenerMediaUrl(msg, 'sticker'))" />
                  <div v-else class="d-flex align-items-center p-2 bg-white rounded shadow-sm">
                    <i class="mdi mdi-sticker-emoji text-warning font-size-24 me-2"></i>
                    <span class="font-size-13 text-muted">Sticker de WhatsApp</span>
                  </div>

                  <div class="wa-sticker-overlay-meta">
                    <span>{{ obtenerHoraMensaje(msg) }}</span>
                    <template v-if="esSaliente(msg)">
                      <i :class="obtenerClasePalomitas(msg)" class="wa-tick-icon"
                        :title="msg.palomitas || msg.estado"></i>
                    </template>
                  </div>
                </div>

                <!-- IMAGE -->
                <div v-else-if="obtenerTipoMensaje(msg) === 'image'" class="wa-media-wrapper">
                  <div class="wa-media-container">
                    <a v-if="obtenerMediaUrl(msg, 'image')" :href="obtenerMediaUrl(msg, 'image')"
                      title="Ver imagen completa" class="d-block wa-media-link cursor-pointer"
                      @click.prevent="abrirLightbox(obtenerMediaUrl(msg, 'image'))">
                      <img :src="obtenerMediaUrl(msg, 'image')" class="wa-media-img" alt="Imagen" />
                    </a>
                    <div v-if="esMensajeSoloMedia(msg)" class="wa-media-overlay-meta">
                      <span>{{ obtenerHoraMensaje(msg) }}</span>
                      <template v-if="esSaliente(msg)">
                        <i :class="obtenerClasePalomitas(msg)" class="wa-tick-icon"
                          :title="msg.palomitas || msg.estado"></i>
                      </template>
                    </div>
                  </div>
                  <div v-if="obtenerTextoMensaje(msg)" class="wa-media-caption">
                    <template v-for="(frag, fIdx) in segmentarTextoConEnlaces(obtenerTextoMensaje(msg))">
                      <a v-if="frag.esUrl" :key="`img-url-${fIdx}`" :href="frag.href" target="_blank"
                        rel="noopener noreferrer" class="wa-msg-link" @click.stop @dblclick.stop>{{ frag.texto }}</a>
                      <span v-else :key="`img-txt-${fIdx}`">{{ frag.texto }}</span>
                    </template>
                  </div>
                </div>

                <!-- VIDEO / GIF -->
                <div v-else-if="obtenerTipoMensaje(msg) === 'video' || obtenerTipoMensaje(msg) === 'gif'"
                  class="wa-media-wrapper">
                  <div class="wa-media-container" :class="{ 'is-gif': esGif(msg) }">
                    <video v-if="obtenerMediaUrl(msg, 'video')" :src="obtenerMediaUrl(msg, 'video')"
                      :controls="!esGif(msg)" :autoplay="esGif(msg)" :loop="esGif(msg)" :muted="esGif(msg)" playsinline
                      class="wa-media-video" @loadedmetadata="onVideoLoaded($event, msg)"></video>
                    <div v-else class="p-3 text-muted font-size-13 text-center">
                      <i class="mdi mdi-video-outline me-1 font-size-22 d-block mb-1"></i>Video de WhatsApp
                    </div>

                    <span v-if="esGif(msg)" class="wa-gif-tag">GIF</span>

                    <div v-if="esMensajeSoloMedia(msg)" class="wa-media-overlay-meta">
                      <span>{{ obtenerHoraMensaje(msg) }}</span>
                      <template v-if="esSaliente(msg)">
                        <i :class="obtenerClasePalomitas(msg)" class="wa-tick-icon"
                          :title="msg.palomitas || msg.estado"></i>
                      </template>
                    </div>
                  </div>
                  <div v-if="obtenerTextoMensaje(msg)" class="wa-media-caption">
                    <template v-for="(frag, fIdx) in segmentarTextoConEnlaces(obtenerTextoMensaje(msg))">
                      <a v-if="frag.esUrl" :key="`vid-url-${fIdx}`" :href="frag.href" target="_blank"
                        rel="noopener noreferrer" class="wa-msg-link" @click.stop @dblclick.stop>{{ frag.texto }}</a>
                      <span v-else :key="`vid-txt-${fIdx}`">{{ frag.texto }}</span>
                    </template>
                  </div>
                </div>

                <!-- AUDIO -->
                <div v-else-if="obtenerTipoMensaje(msg) === 'audio'" class="wa-bubble-audio-wrap">
                  <CmpAudioPlayer v-if="obtenerMediaUrl(msg, 'audio')" :src="obtenerMediaUrl(msg, 'audio')"
                    :es-saliente="esSaliente(msg)" />
                  <div v-else class="d-flex align-items-center p-2 text-muted font-size-13">
                    <i class="mdi mdi-microphone-off font-size-18 me-2"></i>
                    <span>Audio no disponible</span>
                  </div>
                </div>

                <!-- DOCUMENT -->
                <div v-else-if="obtenerTipoMensaje(msg) === 'document'" class="wa-bubble-document-card">
                  <a :href="obtenerDocumentoInfo(msg).url || 'javascript:void(0)'"
                    :target="obtenerDocumentoInfo(msg).url ? '_blank' : '_self'" rel="noopener noreferrer"
                    class="wa-doc-inner" :title="`Descargar / Abrir ${obtenerDocumentoInfo(msg).filename}`">
                    <div class="wa-doc-icon-wrap">
                      <i class="mdi"
                        :class="[obtenerDocumentoInfo(msg).icono, obtenerDocumentoInfo(msg).colorClase]"></i>
                    </div>
                    <div class="wa-doc-details">
                      <span class="wa-doc-title">{{ obtenerDocumentoInfo(msg).filename }}</span>
                      <span class="wa-doc-sub">{{ obtenerDocumentoInfo(msg).extension }} <span class="mx-1">•</span>
                        Documento</span>
                    </div>
                    <div class="wa-doc-download-btn" title="Descargar documento">
                      <i class="mdi mdi-download"></i>
                    </div>
                  </a>
                  <div v-if="obtenerTextoMensaje(msg)" class="wa-doc-caption">
                    <template v-for="(frag, fIdx) in segmentarTextoConEnlaces(obtenerTextoMensaje(msg))">
                      <a v-if="frag.esUrl" :key="`doc-url-${fIdx}`" :href="frag.href" target="_blank"
                        rel="noopener noreferrer" class="wa-msg-link" @click.stop @dblclick.stop>{{ frag.texto }}</a>
                      <span v-else :key="`doc-txt-${fIdx}`">{{ frag.texto }}</span>
                    </template>
                  </div>
                </div>

                <!-- LOCATION -->
                <div v-else-if="obtenerTipoMensaje(msg) === 'location'" class="wa-bubble-location-card">
                  <a v-if="obtenerUbicacionInfo(msg)" :href="obtenerUbicacionInfo(msg).url" target="_blank"
                    rel="noopener noreferrer" class="wa-location-link" title="Abrir en Google Maps">
                    <div class="wa-location-map-preview">
                      <div class="wa-map-grid-pattern"></div>
                      <div class="wa-location-pin-wrap">
                        <i class="mdi mdi-map-marker wa-location-pin text-danger"></i>
                      </div>
                      <div class="wa-location-badge"><i class="mdi mdi-google-maps me-1"></i>Google Maps</div>
                    </div>
                    <div class="wa-location-details">
                      <div v-if="obtenerUbicacionInfo(msg).name" class="wa-location-name">{{
                        obtenerUbicacionInfo(msg).name }}</div>
                      <div v-if="obtenerUbicacionInfo(msg).address" class="wa-location-address">{{
                        obtenerUbicacionInfo(msg).address }}
                      </div>
                      <div v-if="!obtenerUbicacionInfo(msg).name && !obtenerUbicacionInfo(msg).address"
                        class="wa-location-coords">
                        <i class="mdi mdi-crosshairs-gps me-1 text-primary"></i>{{
                          obtenerUbicacionInfo(msg).coordenadasFormateadas }}
                      </div>
                      <div class="wa-location-action"><span>Ver en el mapa</span><i
                          class="mdi mdi-open-in-new font-size-11 ms-1"></i>
                      </div>
                    </div>
                  </a>
                  <div v-else class="p-2 text-muted font-size-13"><i class="mdi mdi-map-marker-off me-1"></i>Ubicación
                    no disponible
                  </div>
                </div>

                <!-- UNSUPPORTED -->
                <div v-else-if="obtenerTipoMensaje(msg) === 'unsupported'" class="wa-bubble-unsupported">
                  <div class="wa-unsupported-icon"><i class="mdi mdi-alert-circle-outline"></i></div>
                  <div class="wa-unsupported-content">
                    <div class="wa-unsupported-title">Mensaje no compatible</div>
                    <div class="wa-unsupported-text">
                      {{ obtenerTextoMensaje(msg) || 'Este tipo de mensaje no es compatible.' }}
                    </div>
                  </div>
                </div>

                <!-- TEMPLATE MESSAGE -->
                <div v-else-if="obtenerTipoMensaje(msg) === 'template'" class="wa-bubble-template-card">
                  <div v-if="obtenerPlantillaInfo(msg).imagenUrl" class="wa-template-media-wrap mb-2">
                    <img :src="obtenerPlantillaInfo(msg).imagenUrl" alt="Comprobante / Encabezado"
                      class="wa-template-header-img cursor-pointer"
                      @click="abrirLightbox(obtenerPlantillaInfo(msg).imagenUrl)" />
                  </div>
                  <div
                    v-else-if="obtenerPlantillaInfo(msg).tipoEncabezado === 'TEXT' && obtenerPlantillaInfo(msg).encabezado"
                    class="wa-template-header-text fw-bold mb-1">
                    {{ obtenerPlantillaInfo(msg).encabezado }}
                  </div>
                  <div class="wa-template-body mb-1">
                    <template v-for="(frag, fIdx) in segmentarTextoConEnlaces(obtenerPlantillaInfo(msg).cuerpo)">
                      <a v-if="frag.esUrl" :key="`tpl-url-${fIdx}`" :href="frag.href" target="_blank"
                        rel="noopener noreferrer" class="wa-msg-link" @click.stop @dblclick.stop>{{ frag.texto }}</a>
                      <span v-else :key="`tpl-txt-${fIdx}`">{{ frag.texto }}</span>
                    </template>
                  </div>
                  <div v-if="obtenerPlantillaInfo(msg).pie" class="wa-template-footer text-muted font-size-11 mb-1">{{
                    obtenerPlantillaInfo(msg).pie }}</div>
                </div>

                <!-- TEXT DEFAULT -->
                <div v-else class="wa-bubble-text" :class="{
                  'wa-emoji-large-1': obtenerConteoEmojis(msg) === 1,
                  'wa-emoji-large-2': obtenerConteoEmojis(msg) === 2,
                  'wa-emoji-large-3': obtenerConteoEmojis(msg) === 3
                }">
                  <template v-for="(frag, fIdx) in segmentarTextoConEnlaces(obtenerTextoMensaje(msg))">
                    <a v-if="frag.esUrl" :key="`txt-url-${fIdx}`" :href="frag.href" target="_blank"
                      rel="noopener noreferrer" class="wa-msg-link" @click.stop @dblclick.stop>{{ frag.texto }}</a>
                    <span v-else :key="`txt-txt-${fIdx}`">{{ frag.texto }}</span>
                  </template>

                  <!-- Vista previa Open Graph (WhatsApp/Facebook style) si el mensaje contiene un enlace -->
                  <a v-if="obtenerPreviewDeMensaje(msg)" :href="obtenerPreviewDeMensaje(msg).url" target="_blank"
                    rel="noopener noreferrer" class="wa-link-preview-card" @click.stop>
                    <div v-if="obtenerPreviewDeMensaje(msg).image" class="wa-link-preview-img-wrap">
                      <img :src="obtenerPreviewDeMensaje(msg).image" :alt="obtenerPreviewDeMensaje(msg).title || 'Preview'" loading="lazy" />
                    </div>
                    <div class="wa-link-preview-content">
                      <div class="wa-link-preview-domain">
                        <img v-if="obtenerPreviewDeMensaje(msg).favicon" :src="obtenerPreviewDeMensaje(msg).favicon"
                          alt="ico" class="wa-link-preview-favicon" />
                        <span class="wa-link-preview-domain-name">{{ obtenerPreviewDeMensaje(msg).site_name || obtenerDominioUrl(obtenerPreviewDeMensaje(msg).url) }}</span>
                        <i class="mdi mdi-open-in-new font-size-11 ms-1 opacity-75"></i>
                      </div>
                      <div v-if="obtenerPreviewDeMensaje(msg).title" class="wa-link-preview-title">
                        {{ obtenerPreviewDeMensaje(msg).title }}
                      </div>
                      <div v-if="obtenerTextoLimpioPreview(obtenerPreviewDeMensaje(msg).description)" class="wa-link-preview-desc">
                        {{ obtenerTextoLimpioPreview(obtenerPreviewDeMensaje(msg).description) }}
                      </div>
                    </div>
                  </a>
                </div>

                <!-- Error específico: Ventana de 24 horas expirada (Error 131047) -->
                <div v-if="esErrorVentana24Horas(msg)"
                  class="wa-bubble-error text-danger font-size-11 mt-1 d-flex align-items-center"
                  title="Han pasado más de 24 horas desde la última interacción. Debe iniciar la conversación con la plantilla oficial.">
                  <i class="mdi mdi-clock-alert-outline me-1 flex-shrink-0"></i>
                  <span>No enviado: ventana de 24h expirada</span>
                </div>

                <!-- Otro tipo de error -->
                <div v-else-if="msg.estado === 'failed' || msg.error_mensaje || msg.error_detalles || msg.error_detalle"
                  class="wa-bubble-error text-danger font-size-11 mt-1 d-flex align-items-center">
                  <i class="mdi mdi-alert-circle-outline me-1 flex-shrink-0"></i>
                  <span>{{ obtenerMensajeErrorLegible(msg) }}</span>
                </div>

                <!-- Metadata: Time & Checks -->
                <div v-if="!esMensajeSoloMedia(msg) && obtenerTipoMensaje(msg) !== 'sticker'" class="wa-bubble-meta">
                  <span class="wa-bubble-time">{{ obtenerHoraMensaje(msg) }}</span>
                  <template v-if="esSaliente(msg)">
                    <i :class="obtenerClasePalomitas(msg)" class="wa-tick-icon"
                      :title="msg.palomitas || msg.estado"></i>
                  </template>
                </div>

                <!-- Reaction Emoji Badge -->
                <div v-if="obtenerReaccion(msg)" class="wa-reaction-badge" :title="'Reacción: ' + obtenerReaccion(msg)">
                  <span class="wa-reaction-emoji">{{ obtenerReaccion(msg) }}</span>
                </div>
              </div>

            </div>
          </div>

          <!-- Banner de número bloqueado -->
          <div v-if="estaBloqueado" class="wa-blocked-chat-footer my-3 text-center d-flex justify-content-center">
            <div class="alert alert-danger d-inline-flex align-items-center shadow-sm py-2 px-3 mb-0" style="max-width: 450px; font-size: 13px;">
              <i class="mdi mdi-block-helper font-size-18 me-2 flex-shrink-0"></i>
              <span>No se puede enviar mensajes a este número de teléfono porque está bloqueado.</span>
            </div>
          </div>

          <!-- Banner / Tarjeta al final de la conversación si la ventana de 24h expiró -->
          <div v-else-if="requiereInicializarConversacion" class="wa-init-chat-footer my-3 text-center d-flex justify-content-center">
            <div class="wa-init-chat-card p-4 rounded-3 text-center shadow-sm">
              <div class="wa-init-chat-icon mb-2">
                <i class="mdi mdi-message-text-fast-outline text-success" style="font-size: 38px;"></i>
              </div>
              <h6 class="fw-semibold mb-1 wa-init-chat-title font-size-15">Ventana de conversación cerrada</h6>
              <p class="text-muted font-size-12 mb-3" style="max-width: 320px; line-height: 1.45;">
                Para iniciar la conversación con este contacto, envía la plantilla oficial de inicio de conversación.
              </p>
              <button type="button"
                class="btn btn-success btn-sm px-3 py-2 d-inline-flex align-items-center justify-content-center shadow-sm"
                :disabled="enviandoPlantillaInicio || cargandoMensajes"
                @click="$emit('inicializar-conversacion', chatSeleccionado)">
                <i class="mdi me-1 font-size-16"
                  :class="enviandoPlantillaInicio ? 'mdi-loading mdi-spin' : 'mdi-send-check-outline'"></i>
                <span>{{ enviandoPlantillaInicio ? 'Enviando plantilla...' : 'Iniciar conversación' }}</span>
              </button>
            </div>
          </div>
        </template>
        </div>
      </SimpleBar>

      <!-- Chat Bottom Input Bar -->
      <div class="wa-input-bar position-relative" :class="{ 'wa-input-bar-blocked': chatEstaVacio || estaBloqueado }">
        <!-- Floating Emoji Picker Popup -->
        <div v-if="mostrarEmojis && !chatEstaVacio && !estaBloqueado" ref="emojiPickerRef" class="wa-emoji-picker-container"
          @click.stop>
          <div class="wa-emoji-picker-header">
            <div class="wa-emoji-tabs">
              <button v-for="cat in categoriasEmojis" :key="cat.id" type="button" class="wa-emoji-tab-btn"
                :class="{ active: categoriaEmojiActiva === cat.id }" :title="cat.label"
                @click="categoriaEmojiActiva = cat.id">
                <i :class="['mdi', cat.icono]"></i>
              </button>
            </div>
            <button type="button" class="wa-emoji-close-btn" @click="mostrarEmojis = false" title="Cerrar emojis">
              <i class="mdi mdi-close"></i>
            </button>
          </div>

          <div class="wa-emoji-grid">
            <button v-for="(emoji, index) in emojisVisibles" :key="`em-${index}-${emoji}`" type="button"
              class="wa-emoji-btn" @click="insertarEmoji(emoji)">
              {{ emoji }}
            </button>
          </div>
        </div>

        <!-- Floating Previews Stack (Reply + Attachment + URL Link) -->
        <div v-if="mensajeCitadoParaResponder || previewUrl || previewUrlInput" class="wa-input-previews-stack">
          <!-- Quoted Message Preview Banner (when replying) -->
          <div v-if="mensajeCitadoParaResponder"
            class="wa-reply-preview-bar d-flex align-items-center justify-content-between p-2 mb-2 bg-light rounded-3 border shadow-sm">
            <div class="d-flex align-items-center flex-grow-1 overflow-hidden">
              <div class="wa-reply-preview-bar-accent"
                :class="{ 'is-outgoing': esSaliente(mensajeCitadoParaResponder) }">
              </div>
              <div class="wa-reply-preview-content flex-grow-1 ms-2 overflow-hidden">
                <div class="wa-reply-preview-author fw-bold font-size-13"
                  :class="esSaliente(mensajeCitadoParaResponder) ? 'text-primary' : 'text-success'">
                  {{ esSaliente(mensajeCitadoParaResponder) ? 'Tú' : (nombreContacto(chatSeleccionado) || 'Contacto') }}
                </div>
                <div class="wa-reply-preview-text text-muted font-size-12 text-truncate d-flex align-items-center">
                  <i v-if="obtenerIconoMensajeDirecto(mensajeCitadoParaResponder)"
                    :class="obtenerIconoMensajeDirecto(mensajeCitadoParaResponder)" class="me-1 font-size-14"></i>
                  <span class="text-truncate">{{ obtenerTextoMensajeDirecto(mensajeCitadoParaResponder) }}</span>
                </div>
              </div>
              <div v-if="obtenerThumbMensajeDirecto(mensajeCitadoParaResponder)"
                class="wa-reply-preview-thumb ms-2 flex-shrink-0">
                <img :src="obtenerThumbMensajeDirecto(mensajeCitadoParaResponder)" alt="thumbnail"
                  style="width: 44px; height: 44px; object-fit: cover; border-radius: 4px;" />
              </div>
            </div>
            <button type="button" class="btn btn-sm btn-link text-muted p-1 ms-2 text-decoration-none"
              @click="cancelarRespuesta" title="Cancelar respuesta (Esc)">
              <i class="mdi mdi-close font-size-18"></i>
            </button>
          </div>

          <!-- Preview file banner before send -->
          <div v-if="previewUrl"
            class="wa-file-upload-preview d-flex align-items-center p-2 mb-2 bg-light rounded-3 border shadow-sm">
            <div class="position-relative me-3 flex-shrink-0">
              <img v-if="tipoArchivo === 'image'" :src="previewUrl" alt="Vista previa"
                style="max-height: 60px; max-width: 90px; object-fit: cover; border-radius: 6px;" />
              <div v-else class="d-flex align-items-center justify-content-center bg-white rounded border"
                style="width: 50px; height: 50px;">
                <i class="mdi font-size-28" :class="[obtenerIconoPreview.icono, obtenerIconoPreview.color]"></i>
              </div>
            </div>
            <div class="flex-grow-1 overflow-hidden me-2">
              <div class="fw-semibold font-size-13 text-truncate">{{ archivoSeleccionado?.name }}</div>
              <div class="text-muted font-size-11">
                {{ (archivoSeleccionado?.size / 1024).toFixed(1) }} KB
                <span class="ms-1 badge bg-secondary-subtle text-secondary text-uppercase font-size-10">{{ tipoArchivo
                  }}</span>
              </div>
            </div>
            <button type="button" class="btn btn-sm text-danger p-1" @click="limpiarArchivoSeleccionado"
              title="Quitar archivo">
              <i class="mdi mdi-close font-size-18"></i>
            </button>
          </div>

          <!-- Preview URL link banner before send (WhatsApp Web style) -->
          <div v-if="previewUrlInput && !previewUrl"
            class="wa-url-input-preview d-flex align-items-center p-2 mb-2 bg-light rounded-3 border shadow-sm">
            <div v-if="previewUrlInput.image" class="position-relative me-3 flex-shrink-0">
              <img :src="previewUrlInput.image" alt="Preview"
                style="width: 54px; height: 54px; object-fit: cover; border-radius: 6px;" />
            </div>
            <div class="flex-grow-1 overflow-hidden me-2">
              <div class="fw-semibold font-size-13 text-truncate">{{ previewUrlInput.title || previewUrlInput.site_name }}</div>
              <div v-if="obtenerTextoLimpioPreview(previewUrlInput.description)" class="text-muted font-size-11 text-truncate">
                {{ obtenerTextoLimpioPreview(previewUrlInput.description) }}
              </div>
              <div class="text-muted font-size-10 d-flex align-items-center">
                <img v-if="previewUrlInput.favicon" :src="previewUrlInput.favicon" alt="ico"
                  style="width: 12px; height: 12px; margin-right: 4px;" />
                <span>{{ previewUrlInput.site_name || previewUrlInput.url }}</span>
              </div>
            </div>
            <button type="button" class="btn btn-sm btn-link text-muted p-1 ms-1 text-decoration-none"
              @click="previewUrlInput = null" title="Descartar vista previa">
              <i class="mdi mdi-close font-size-18"></i>
            </button>
          </div>
        </div>

        <!-- Attachment (File) Button -->
        <input ref="fileInputArchivo" type="file" class="d-none" @change="alSeleccionarArchivo" />
        <button type="button" class="btn wa-icon-btn me-2" :disabled="chatEstaVacio || estaBloqueado"
          :title="estaBloqueado ? 'Número bloqueado' : (chatEstaVacio ? 'Inicia la conversación para poder enviar mensajes' : 'Adjuntar archivo (imagen, video, audio, documento, txt...)')"
          @click="triggerSeleccionarArchivo">
          <i class="mdi mdi-paperclip font-size-22"></i>
        </button>

        <!-- Emoji Button Toggle -->
        <button ref="emojiBtnRef" type="button" class="btn wa-icon-btn me-1" :class="{ 'text-success': mostrarEmojis }"
          :disabled="chatEstaVacio || estaBloqueado"
          :title="estaBloqueado ? 'Número bloqueado' : (chatEstaVacio ? 'Inicia la conversación para poder enviar mensajes' : 'Emojis')"
          @click.stop="toggleEmojis">
          <i
            :class="mostrarEmojis ? 'mdi mdi-emoticon font-size-22' : 'mdi mdi-emoticon-happy-outline font-size-22'"></i>
        </button>

        <!-- Quick Replies Button Toggle -->
        <button type="button" class="btn wa-icon-btn me-2" :class="{ 'text-warning': menuRespuestasRapidasVisible }"
          :disabled="chatEstaVacio || estaBloqueado" :title="estaBloqueado ? 'Número bloqueado' : 'Respuestas rápidas (/)'"
          @click.stop="toggleMenuRespuestasRapidas">
          <i class="mdi mdi-lightning-bolt-outline font-size-22"></i>
        </button>

        <!-- Message Input Box -->
        <div class="wa-input-box-wrap flex-grow-1 me-2 position-relative">
          <!-- Componente Selector de Respuestas Rápidas -->
          <CmpRespuestasRapidasChat ref="cmpRespuestasRapidas" :visible="menuRespuestasRapidasVisible"
            :filtro="filtroRespuestasRapidas" :chat-seleccionado="chatSeleccionado"
            @seleccionar="onRespuestaRapidaSeleccionada" @cerrar="menuRespuestasRapidasVisible = false" />

          <textarea ref="inputMensaje" rows="1" class="form-control wa-msg-input"
            :placeholder="estaBloqueado ? 'Número bloqueado. No se pueden enviar mensajes a este contacto.' : (chatEstaVacio ? 'Inicia la conversación con la plantilla para enviar mensajes...' : (archivoSeleccionado ? 'Añade una descripción (opcional)...' : 'Escribe un mensaje o usa / para respuestas rápidas...'))"
            :disabled="chatEstaVacio || estaBloqueado || enviando || enviandoMensaje" v-model="mensajeActual"
            @input="alEscribirMensaje" @keydown.down.prevent="navegarRespuestasRapidas(1)"
            @keydown.up.prevent="navegarRespuestasRapidas(-1)" @keydown.enter.exact.prevent="alPresionarEnter"
            @keydown.esc="cancelarRespuesta"></textarea>
        </div>

        <!-- Send Button -->
        <button type="button" class="btn wa-send-btn"
          :class="{ 'wa-send-btn-active': (archivoSeleccionado || (mensajeActual && mensajeActual.trim())) && !chatEstaVacio && !estaBloqueado && !enviando && !enviandoMensaje }"
          :disabled="enviando || enviandoMensaje || chatEstaVacio || estaBloqueado || (!archivoSeleccionado && (!mensajeActual || !mensajeActual.trim()))"
          @click="enviar"
          :title="estaBloqueado ? 'Número bloqueado' : (chatEstaVacio ? 'Inicia la conversación para poder enviar mensajes' : 'Enviar mensaje')">
          <i class="mdi mdi-send"></i>
        </button>
      </div>
    </template>

    <!-- Empty State (No Chat Selected) -->
    <div v-else class="wa-empty-state">
      <div class="wa-empty-content text-center">
        <div class="wa-empty-icon mb-3">
          <i class="mdi mdi-whatsapp text-success" style="font-size: 78px; opacity: 0.85;"></i>
        </div>
        <h4 class="wa-empty-title mb-2">WhatsApp Web</h4>
        <p class="wa-empty-text text-muted mb-4">
          Envía y recibe mensajes con tus clientes directamente desde el sistema.<br>
          Selecciona un chat de la lista de contactos para comenzar una conversación.
        </p>
        <button class="btn btn-success d-lg-none px-4 py-2" @click="$emit('abrir-sidebar')">
          <i class="mdi mdi-message-text-outline me-1"></i> Seleccionar un chat
        </button>
        <div class="wa-empty-footer text-muted font-size-12 mt-5">
          <i class="mdi mdi-lock font-size-14 me-1"></i> Cifrado de extremo a extremo
        </div>
      </div>
    </div>

    <!-- Lightbox -->
    <vue-easy-lightbox :visible="lightboxVisible" :imgs="lightboxImgs" :index="lightboxIndex"
      @hide="lightboxVisible = false"></vue-easy-lightbox>
  </div>
</template>

<script>
import { SimpleBar } from "simplebar-vue3";
import VueEasyLightbox from "vue-easy-lightbox";
import CmpDualAvatar from "./CmpDualAvatar.vue";
import CmpAudioPlayer from "./CmpAudioPlayer.vue";
import CmpRespuestasRapidasChat from "./CmpRespuestasRapidasChat.vue";
import {
  CATEGORIAS_EMOJIS,
  parsearPayload,
  obtenerTipoMensaje,
  obtenerTextoMensaje,
  obtenerMediaApiUrl,
  obtenerMediaUrl,
  obtenerDocumentoInfo,
  obtenerNombreArchivo,
  obtenerPlantillaInfo,
  obtenerUbicacionInfo,
  obtenerObjetoFecha,
  obtenerHoraMensaje,
  mostrarSeparadorFecha,
  obtenerEtiquetaFecha,
  obtenerWamid,
  coincideId,
  obtenerKeyMensajeId,
  obtenerReaccion,
  esSaliente,
  esErrorVentana24Horas,
  obtenerMensajeErrorLegible,
  obtenerClasePalomitas,
  obtenerIdCliente,
  esClienteGenerico,
  nombreContacto,
  inicialContacto,
  extraerContextId,
  obtenerMensajeCitado,
  obtenerKeyCache,
  cargarConversacionDeCache,
  guardarConversacionEnCache,
  purgarCachesAntiguas,
  eliminarCacheChat,
  obtenerConteoEmojis,
  esMensajeMedia,
  esMensajeSoloMedia,
  esGif
} from "./whatsappHelpers.js";
import WhatsappSrv from "@/services/WhatsappSrv.js";

export default {
  name: "CmpVentanaChat",
  components: {
    SimpleBar,
    VueEasyLightbox,
    CmpDualAvatar,
    CmpAudioPlayer,
    CmpRespuestasRapidasChat
  },
  props: {
    chatSeleccionado: { type: Object, default: null },
    mensajes: { type: Array, default: () => [] },
    cargandoMensajes: { type: Boolean, default: false },
    cargandoMasMensajes: { type: Boolean, default: false },
    noHayMasMensajesHistoricos: { type: Boolean, default: false },
    enviandoMensaje: { type: Boolean, default: false },
    enviandoPlantillaInicio: { type: Boolean, default: false },
    panelInfoVisible: { type: Boolean, default: false },
    procesandoBloqueo: { type: Boolean, default: false }
  },
  emits: [
    "cargar-mas-mensajes",
    "enviar-mensaje",
    "inicializar-conversacion",
    "abrir-sidebar",
    "toggle-panel-info",
    "abrir-panel-info",
    "cerrar-chat",
    "ir-a-detalle-cliente",
    "vaciar-chat",
    "bloquear-contacto",
    "desbloquear-contacto",
    "eliminar-chat"
  ],
  data() {
    return {
      mensajeActual: "",
      mensajeCitadoParaResponder: null,
      archivoSeleccionado: null,
      tipoArchivo: "document",
      previewUrl: null,
      mostrarEmojis: false,
      mapaVideosGif: {},
      lightboxVisible: false,
      lightboxImgs: [],
      lightboxIndex: 0,
      mensajesCache: [],
      ultimaActualizacionCache: null,
      categoriaEmojiActiva: "caras",
      categoriasEmojis: CATEGORIAS_EMOJIS,
      enviando: false,
      menuRespuestasRapidasVisible: false,
      filtroRespuestasRapidas: "",
      mapaUrlPreviews: {},
      cargandoUrlPreviews: {},
      urlDetectadaInput: null,
      previewUrlInput: null,
      timerDebounceUrlInput: null
    };
  },
  computed: {
    obtenerIconoPreview() {
      if (!this.archivoSeleccionado) return { icono: "mdi-file-document-outline", color: "text-primary" };
      const name = this.archivoSeleccionado.name || "";
      const ext = name.includes(".") ? name.split(".").pop().toLowerCase() : "";
      if (ext === "pdf") return { icono: "mdi-file-pdf-box", color: "text-danger" };
      if (["doc", "docx", "txt"].includes(ext)) return { icono: "mdi-file-word-box", color: "text-primary" };
      if (["xls", "xlsx", "csv"].includes(ext)) return { icono: "mdi-file-excel-box", color: "text-success" };
      if (["zip", "rar", "7z", "tar", "gz"].includes(ext)) return { icono: "mdi-folder-zip", color: "text-warning" };
      if (["mp3", "wav", "ogg", "aac", "m4a"].includes(ext)) return { icono: "mdi-music", color: "text-info" };
      if (["mp4", "mov", "avi", "mkv", "3gp"].includes(ext)) return { icono: "mdi-video", color: "text-purple" };
      return { icono: "mdi-file-document-outline", color: "text-primary" };
    },
    emojisVisibles() {
      return this.categoriasEmojis[this.categoriaEmojiActiva]?.emojis || [];
    },
    listaMensajes() {
      let raw = [];
      if (Array.isArray(this.mensajes)) {
        raw = this.mensajes;
      } else if (this.mensajesCache && this.mensajesCache.length > 0) {
        raw = this.mensajesCache;
      } else if (this.chatSeleccionado?.mensajes && this.chatSeleccionado.mensajes.length > 0) {
        raw = this.chatSeleccionado.mensajes;
      } else if (this.chatSeleccionado?.ultimo_mensaje_whatsapp || this.chatSeleccionado?.ultimo_mensaje_whatssap) {
        const uMsg = this.chatSeleccionado.ultimo_mensaje_whatsapp || this.chatSeleccionado.ultimo_mensaje_whatssap;
        if (uMsg && typeof uMsg === "object") {
          raw = [uMsg];
        }
      }
      const mapaReacciones = {};
      const lista = [];
      const mapaIds = new Map();

      raw.forEach((m, idx) => {
        if (!m) return;
        m._rawIndex = idx;
        const p = parsearPayload(m);

        // 1. Extraer reacciones
        const esReaccion = m.type === "reaction" || m.tipo === "reaction" || p.type === "reaction" || Boolean(m.reaction?.message_id || p.reaction?.message_id);
        if (esReaccion) {
          const r = m.reaction || p.reaction || p.entry?.[0]?.changes?.[0]?.value?.messages?.[0]?.reaction || p.messages?.[0]?.reaction || {};
          const targetId = r.message_id || m.message_id || p.message_id;
          if (targetId) mapaReacciones[targetId] = (r.emoji !== undefined ? r.emoji : (m.emoji || "")).trim();
          return;
        }

        // 2. Ignorar eventos de solo status
        if (m.type === "status" || m.tipo === "status" || p.type === "status" || Boolean(m.statuses || p.statuses)) return;

        // 3. Ignorar items sin contenido
        const tipo = obtenerTipoMensaje(m);
        const tieneTexto = Boolean(obtenerTextoMensaje(m));
        const esTipoEspecial = ["sticker", "document", "location", "audio", "unsupported", "template"].includes(tipo);
        if (!tieneTexto && !esMensajeMedia(m) && !esTipoEspecial) return;

        // 4. Claves únicas: wamid e ID (Solo deduplicar si el ID es definitivo o tiene un wamid genuino)
        const wamid = obtenerWamid(m);
        const idStr = m.id !== undefined && m.id !== null ? String(m.id) : null;
        const esTemp = typeof m.id === "string" && m.id.startsWith("temp_");

        // Si ya registramos este mensaje por wamid o por id numérico, consolidar
        // IMPORTANTE: Si es un ID numérico de BD pero diferente índice o diferente hora/url, no colapsarlo si son mensajes distintos
        let existente = null;
        if (wamid && mapaIds.has(wamid)) {
          existente = mapaIds.get(wamid);
        } else if (idStr && !esTemp && mapaIds.has(idStr)) {
          const itemPrevio = mapaIds.get(idStr);
          // Si tienen mismo ID pero URLs de media o contenido diferente, son items distintos en BD (p.ej. queries sin id unívoco)
          const urlM = m.url_imagen || m.media_url || obtenerMediaUrl(m, tipo);
          const urlPrev = itemPrevio.url_imagen || itemPrevio.media_url || obtenerMediaUrl(itemPrevio, obtenerTipoMensaje(itemPrevio));
          if (!urlM || !urlPrev || urlM === urlPrev) {
            existente = itemPrevio;
          }
        }

        if (existente) {
          Object.assign(existente, m);
          if (m.url_imagen && !existente.url_imagen) existente.url_imagen = m.url_imagen;
          if (m.media_url && !existente.media_url) existente.media_url = m.media_url;
          if (wamid) mapaIds.set(wamid, existente);
          if (idStr) mapaIds.set(idStr, existente);
          return;
        }

        const textoM = obtenerTextoMensaje(m);
        const filenameM = obtenerNombreArchivo(m) || m.filename || "";

        // 5. Manejo de mensajes temporales vs definitivos
        if (esTemp) {
          // Si ya existe en la lista definitiva O ya existe otro mensaje temporal saliente idéntico
          const yaExiste = lista.find((item) => {
            const itemEsTemp = typeof item.id === "string" && item.id.startsWith("temp_");
            if (!esSaliente(item, this.chatSeleccionado)) return false;

            // Si ambos son temporales con el mismo ID o texto
            if (itemEsTemp) {
              if (item.id === m.id) return true;
              if (textoM && obtenerTextoMensaje(item) === textoM) {
                const diffTiempo = Math.abs(obtenerObjetoFecha(item).getTime() - obtenerObjetoFecha(m).getTime());
                return diffTiempo < 300000;
              }
              return false;
            }

            const diffTiempo = Math.abs(obtenerObjetoFecha(item).getTime() - obtenerObjetoFecha(m).getTime());
            if (textoM && obtenerTextoMensaje(item) === textoM) {
              return diffTiempo < 300000;
            }
            const itemTipo = obtenerTipoMensaje(item);
            if (tipo === itemTipo && ["image", "video", "audio", "document", "sticker"].includes(tipo)) {
              const itemFn = obtenerNombreArchivo(item) || item.filename || "";
              if (filenameM && itemFn && filenameM === itemFn) return true;
              if (diffTiempo < 120000) return true;
            }
            return false;
          });
          if (yaExiste) {
            if (m.url_imagen && !yaExiste.url_imagen) yaExiste.url_imagen = m.url_imagen;
            if (m.media_url && !yaExiste.media_url) yaExiste.media_url = m.media_url;
            return;
          }
        } else if (esSaliente(m, this.chatSeleccionado)) {
          const indexTemp = lista.findIndex((item) => {
            if (!(typeof item.id === "string" && item.id.startsWith("temp_"))) return false;
            const diffTiempo = Math.abs(obtenerObjetoFecha(item).getTime() - obtenerObjetoFecha(m).getTime());
            if (textoM && obtenerTextoMensaje(item) === textoM) {
              return diffTiempo < 300000;
            }
            const itemTipo = obtenerTipoMensaje(item);
            if (tipo === itemTipo && ["image", "video", "audio", "document", "sticker"].includes(tipo)) {
              const itemFn = obtenerNombreArchivo(item) || item.filename || "";
              if (filenameM && itemFn && filenameM === itemFn) return true;
              if (diffTiempo < 120000) return true;
            }
            return false;
          });
          if (indexTemp !== -1) {
            const itemTemp = lista[indexTemp];
            m.url_imagen = m.url_imagen || itemTemp.url_imagen;
            m.media_url = m.media_url || itemTemp.media_url;
            m.filename = m.filename || itemTemp.filename;
            lista[indexTemp] = m;
            if (wamid) mapaIds.set(wamid, m);
            if (idStr) mapaIds.set(idStr, m);
            return;
          }
        }

        if (wamid) mapaIds.set(wamid, m);
        if (idStr) mapaIds.set(idStr, m);
        lista.push(m);
      });

      // 7. Ordenamiento cronológico garantizado
      lista.sort((a, b) => {
        const timeA = obtenerObjetoFecha(a).getTime();
        const timeB = obtenerObjetoFecha(b).getTime();
        if (timeA !== timeB) {
          return timeA - timeB;
        }

        const idA = typeof a.id === "number" || (!isNaN(a.id) && !String(a.id).startsWith("temp_")) ? Number(a.id) : 0;
        const idB = typeof b.id === "number" || (!isNaN(b.id) && !String(b.id).startsWith("temp_")) ? Number(b.id) : 0;
        if (idA && idB && idA !== idB) {
          return idA - idB;
        }

        if (idA && !idB) return -1;
        if (!idA && idB) return 1;

        return (a._rawIndex || 0) - (b._rawIndex || 0);
      });

      return lista.map((m) => {
        const wamid = obtenerWamid(m);
        const idKey = wamid || String(m.id || "");
        return {
          ...m,
          reaccion: mapaReacciones[wamid] || mapaReacciones[idKey] || obtenerReaccion(m)
        };
      });
    },
    chatEstaVacio() {
      return !this.listaMensajes || this.listaMensajes.length === 0;
    },
    requiereInicializarConversacion() {
      // 1. Si el chat está completamente vacío, requiere iniciar conversación con plantilla
      if (!this.listaMensajes || this.listaMensajes.length === 0) {
        return true;
      }

      const mensajes = this.listaMensajes;

      // 2. Si el último mensaje es saliente y se envió/entregó exitosamente (sent, delivered, read)
      // o está en proceso (con palomitas sin error), la conversación está activa: NO requiere plantilla
      const ultimo = mensajes[mensajes.length - 1];
      if (esSaliente(ultimo, this.chatSeleccionado)) {
        // Solo requiere plantilla si ese último mensaje falló específicamente por ventana de 24 horas
        if (esErrorVentana24Horas(ultimo)) {
          return true;
        }

        // Si fue enviado exitosamente o no tiene error de 24 horas, no mostrar banner de ventana cerrada
        return false;
      }

      // 3. Si el último mensaje es entrante (del cliente):
      // Si el cliente respondió o escribió hace menos de 24 horas, la ventana está abierta
      const fechaUltimo = obtenerObjetoFecha(ultimo);
      if (fechaUltimo && !isNaN(fechaUltimo.getTime())) {
        const diffMs = Date.now() - fechaUltimo.getTime();
        const horasTranscurridas = diffMs / (1000 * 60 * 60);
        if (horasTranscurridas < 24) {
          return false;
        }
      }

      // Si han pasado más de 24 horas desde que el cliente escribió y aún no se le ha respondido
      return true;
    },
    estaBloqueado() {
      return Boolean(this.chatSeleccionado && Number(this.chatSeleccionado.bloqueado) === 1);
    }
  },
  watch: {
    chatSeleccionado: {
      immediate: true,
      handler(nuevoChat, antiguoChat) {
        const idNuevo = nuevoChat ? (nuevoChat.id || nuevoChat.id_telefono_cliente || nuevoChat.id_cliente || nuevoChat.numero) : null;
        const idAntiguo = antiguoChat ? (antiguoChat.id || antiguoChat.id_telefono_cliente || antiguoChat.id_cliente || antiguoChat.numero) : null;
        const esCambioDeChat = String(idNuevo) !== String(idAntiguo);

        if (esCambioDeChat) {
          this.mostrarEmojis = false;
          this.menuRespuestasRapidasVisible = false;
          this.mensajeCitadoParaResponder = null;
          this.limpiarArchivoSeleccionado();

          if (nuevoChat) {
            const cache = cargarConversacionDeCache(nuevoChat);
            if (cache && Array.isArray(cache.mensajes) && cache.mensajes.length > 0) {
              this.mensajesCache = cache.mensajes;
              this.ultimaActualizacionCache = cache.ultima_actualizacion || null;
            } else {
              this.mensajesCache = [];
              this.ultimaActualizacionCache = null;
            }
          } else {
            this.mensajesCache = [];
            this.ultimaActualizacionCache = null;
          }

          this.scrollAlFinal(true);
        }
      }
    },
    mensajes: {
      deep: true,
      handler(nuevosMensajes) {
        if (this.chatSeleccionado && Array.isArray(nuevosMensajes)) {
          if (nuevosMensajes.length === 0) {
            this.mensajesCache = [];
            this.eliminarCacheChat(this.chatSeleccionado);
          } else {
            this.$nextTick(() => {
              const listaLimpia = this.listaMensajes;
              this.mensajesCache = listaLimpia;
              this.guardarConversacionEnCache(this.chatSeleccionado, listaLimpia);
            });
          }
        }
      }
    },
    listaMensajes: {
      deep: true,
      handler(nuevaLista, viejaLista) {
        // Solo hacer auto-scroll hacia abajo si no estamos cargando un lote anterior hacia arriba
        if (this.cargandoMasMensajes) return;
        const cantNueva = Array.isArray(nuevaLista) ? nuevaLista.length : 0;
        const cantVieja = Array.isArray(viejaLista) ? viejaLista.length : 0;
        // Si llegaron mensajes nuevos al final
        if (cantNueva >= cantVieja) {
          const contenedor = this.$refs.conversationScroll;
          if (contenedor?.$el) {
            const el = contenedor.$el.querySelector(".simplebar-content-wrapper") || contenedor.$el;
            const distanciaDelFondo = el.scrollHeight - el.scrollTop - el.clientHeight;
            // Si el usuario está cerca del final (menos de 200px) o es primera carga
            if (distanciaDelFondo < 200 || cantVieja === 0) {
              this.scrollAlFinal();
            }
          } else {
            this.scrollAlFinal();
          }
        }
      }
    }
  },
  mounted() {
    document.addEventListener("click", this.verificarClickAfueraEmoji);
    this.$nextTick(() => {
      const contenedor = this.$refs.conversationScroll;
      if (contenedor?.$el) {
        const el = contenedor.$el.querySelector(".simplebar-content-wrapper") || contenedor.$el;
        if (el) {
          el.addEventListener("scroll", this.onScrollConversacion, { passive: true });
        }
      }
    });
  },
  beforeUnmount() {
    document.removeEventListener("click", this.verificarClickAfueraEmoji);
    const contenedor = this.$refs.conversationScroll;
    if (contenedor?.$el) {
      const el = contenedor.$el.querySelector(".simplebar-content-wrapper") || contenedor.$el;
      if (el) {
        el.removeEventListener("scroll", this.onScrollConversacion);
      }
    }
  },
  methods: {
    // Funciones puras de parsing y formateo
    extraerPrimeraUrl(texto) {
      if (!texto || typeof texto !== "string") return null;
      const urlRegex = /((?:https?:\/\/|www\.)[^\s<]+)/i;
      const match = texto.match(urlRegex);
      if (!match) return null;
      let url = match[0];
      const puntuacionFinal = url.match(/[.,;:!?)]+$/);
      if (puntuacionFinal) {
        url = url.slice(0, -puntuacionFinal[0].length);
      }
      return /^https?:\/\//i.test(url) ? url : `https://${url}`;
    },
    obtenerDominioUrl(url) {
      if (!url) return "";
      try {
        const u = new URL(url);
        return u.hostname.replace(/^www\./i, "");
      } catch (e) {
        return url;
      }
    },
    obtenerTextoLimpioPreview(texto) {
      if (!texto || typeof texto !== "string") return "";
      // Quitar etiquetas HTML como <p>, </p>, etc., y espacios duplicados
      return texto.replace(/<\/?[^>]+(>|$)/g, "").replace(/\s+/g, " ").trim();
    },
    obtenerPreviewDeMensaje(msg) {
      const texto = obtenerTextoMensaje(msg);
      const url = this.extraerPrimeraUrl(texto);
      if (!url) return null;

      // Si ya tenemos en memoria el preview
      if (this.mapaUrlPreviews[url]) {
        return this.mapaUrlPreviews[url];
      }

      // Si no está cargando ni en memoria, intentar cargar desde caché LocalStorage o solicitarlo al backend
      this.cargarPreviewUrl(url);
      return null;
    },
    cargarPreviewUrl(url) {
      if (!url || this.cargandoUrlPreviews[url] || this.mapaUrlPreviews[url]) return;

      const cacheKey = `wa_preview_${url}`;
      try {
        const guardado = localStorage.getItem(cacheKey);
        if (guardado) {
          const parsed = JSON.parse(guardado);
          if (parsed && (parsed.title || parsed.description || parsed.image)) {
            this.mapaUrlPreviews = { ...this.mapaUrlPreviews, [url]: parsed };
            return;
          }
        }
      } catch (e) {}

      this.cargandoUrlPreviews = { ...this.cargandoUrlPreviews, [url]: true };
      WhatsappSrv.previewUrl(url)
        .then((response) => {
          const data = response && response.data !== undefined ? response.data : response;
          if (data && (data.title || data.description || data.image)) {
            this.mapaUrlPreviews = { ...this.mapaUrlPreviews, [url]: data };
            try {
              localStorage.setItem(cacheKey, JSON.stringify(data));
            } catch (e) {}
          }
        })
        .catch(() => {
          // Si falla o no tiene preview, evitar reintentar en bucle
          this.mapaUrlPreviews = { ...this.mapaUrlPreviews, [url]: null };
        })
        .finally(() => {
          const copia = { ...this.cargandoUrlPreviews };
          delete copia[url];
          this.cargandoUrlPreviews = copia;
        });
    },
    segmentarTextoConEnlaces(texto) {
      if (!texto || typeof texto !== "string") return [];
      const urlRegex = /((?:https?:\/\/|www\.)[^\s<]+)/gi;
      const partes = [];
      let ultimoIndice = 0;
      let match;

      while ((match = urlRegex.exec(texto)) !== null) {
        const inicio = match.index;
        let urlDetectada = match[0];
        let sufijo = "";

        const puntuacionFinal = urlDetectada.match(/[.,;:!?)]+$/);
        if (puntuacionFinal) {
          sufijo = puntuacionFinal[0];
          urlDetectada = urlDetectada.slice(0, -sufijo.length);
        }

        if (inicio > ultimoIndice) {
          partes.push({
            esUrl: false,
            texto: texto.slice(ultimoIndice, inicio)
          });
        }

        const href = /^https?:\/\//i.test(urlDetectada)
          ? urlDetectada
          : `https://${urlDetectada}`;

        partes.push({
          esUrl: true,
          texto: urlDetectada,
          href
        });

        if (sufijo) {
          partes.push({
            esUrl: false,
            texto: sufijo
          });
        }

        ultimoIndice = inicio + match[0].length;
      }

      if (ultimoIndice < texto.length) {
        partes.push({
          esUrl: false,
          texto: texto.slice(ultimoIndice)
        });
      }

      return partes;
    },
    parsearPayload,
    obtenerTipoMensaje,
    obtenerTextoMensaje,
    obtenerMediaApiUrl,
    obtenerMediaUrl,
    obtenerDocumentoInfo,
    obtenerNombreArchivo,
    obtenerPlantillaInfo,
    obtenerUbicacionInfo,
    obtenerObjetoFecha,
    obtenerHoraMensaje,
    mostrarSeparadorFecha,
    obtenerEtiquetaFecha,
    obtenerWamid,
    coincideId,
    obtenerKeyMensajeId,
    obtenerReaccion,
    esErrorVentana24Horas,
    esSaliente(msg) {
      return esSaliente(msg, this.chatSeleccionado);
    },
    obtenerMensajeErrorLegible,
    obtenerClasePalomitas,
    obtenerIdCliente,
    esClienteGenerico,
    nombreContacto,
    inicialContacto,
    extraerContextId,
    obtenerConteoEmojis,
    esMensajeMedia,
    esMensajeSoloMedia,
    obtenerKeyCache,
    cargarConversacionDeCache,
    purgarCachesAntiguas,

    // Cache con sincronización de estado local
    guardarConversacionEnCache(chat, mensajes) {
      const ts = guardarConversacionEnCache(chat, mensajes);
      if (ts) this.ultimaActualizacionCache = ts;
      return ts;
    },
    eliminarCacheChat(chat) {
      eliminarCacheChat(chat);
      this.mensajesCache = [];
      this.ultimaActualizacionCache = null;
    },

    // Detección y reproducción de GIF animado
    esGif(msg) {
      return esGif(msg, this.mapaVideosGif);
    },
    onVideoLoaded(e, msg) {
      const video = e.target;
      const key = msg.id || msg.wamid;
      if (key && !isNaN(video?.duration) && video.duration > 0 && video.duration < 40) {
        this.mapaVideosGif[key] = true;
        video.muted = true;
        video.loop = true;
        video.autoplay = true;
        video.play().catch(() => { });
      }
    },

    // Mensajes citados y respuestas
    obtenerMensajeCitado(msg) {
      return obtenerMensajeCitado(msg, this.listaMensajes);
    },
    esSalienteCitado(msg) {
      if (!msg) return false;
      const citado = this.obtenerMensajeCitado(msg) || (msg === this.mensajeCitadoParaResponder ? msg : null);
      if (!citado) return false;
      if (!citado.esPlaceholder) return esSaliente(citado, this.chatSeleccionado);
      if (citado.direccion === "saliente" || citado.from === "me") return true;
      if (citado.direccion === "entrante") return false;
      const p = parsearPayload(msg);
      const ctx = msg.context || p.context || p.meta_request?.context || {};
      if (ctx.es_saliente_citado || ctx.es_saliente) return true;
      const numChat = (this.chatSeleccionado?.numero || "").replace(/\D/g, "");
      const fromNum = String(citado.from || ctx.from || "").replace(/\D/g, "");
      if (fromNum && numChat) {
        return !fromNum.includes(numChat) && !numChat.includes(fromNum);
      }
      return false;
    },
    obtenerAutorCitado(msg) {
      if (!msg) return "";
      return this.esSalienteCitado(msg) ? "Tú" : (nombreContacto(this.chatSeleccionado) || "Contacto");
    },
    obtenerTextoCitado(msg) {
      if (!msg) return "";
      const citado = this.obtenerMensajeCitado(msg);
      if (!citado) return "";
      const t = obtenerTextoMensaje(citado);
      if (t) return t;
      const fn = obtenerNombreArchivo(citado);
      if (fn) return fn;
      const tipo = obtenerTipoMensaje(citado);
      const mapa = {
        image: "Foto",
        video: "Video",
        audio: "Audio",
        voice: "Mensaje de voz",
        sticker: "Sticker",
        document: "Documento",
        location: "Ubicación"
      };
      return mapa[tipo] || "Mensaje";
    },
    obtenerIconoCitado(msg) {
      if (!msg) return null;
      const citado = this.obtenerMensajeCitado(msg);
      if (!citado) return null;
      const tipo = obtenerTipoMensaje(citado);
      const mapa = {
        image: "mdi mdi-image-outline",
        video: "mdi mdi-video-outline",
        audio: "mdi mdi-microphone-outline",
        sticker: "mdi mdi-sticker-emoji",
        document: "mdi mdi-file-document-outline",
        location: "mdi mdi-map-marker-outline"
      };
      return mapa[tipo] || null;
    },
    obtenerThumbCitado(msg) {
      if (!msg) return null;
      const citado = this.obtenerMensajeCitado(msg);
      if (!citado) return null;
      const tipo = obtenerTipoMensaje(citado);
      if (tipo === "image") return obtenerMediaUrl(citado, "image");
      if (tipo === "video" || tipo === "gif") return obtenerMediaUrl(citado, "video");
      if (tipo === "sticker") return obtenerMediaUrl(citado, "sticker");
      return null;
    },
    obtenerTextoMensajeDirecto(msg) {
      if (!msg) return "";
      const t = obtenerTextoMensaje(msg);
      if (t) return t;
      const fn = obtenerNombreArchivo(msg);
      if (fn) return fn;
      const tipo = obtenerTipoMensaje(msg);
      const mapa = {
        image: "Foto",
        video: "Video",
        audio: "Audio",
        voice: "Mensaje de voz",
        sticker: "Sticker",
        document: "Documento",
        location: "Ubicación"
      };
      return mapa[tipo] || "Mensaje";
    },
    obtenerIconoMensajeDirecto(msg) {
      if (!msg) return null;
      const tipo = obtenerTipoMensaje(msg);
      const mapa = {
        image: "mdi mdi-image-outline",
        video: "mdi mdi-video-outline",
        audio: "mdi mdi-microphone-outline",
        sticker: "mdi mdi-sticker-emoji",
        document: "mdi mdi-file-document-outline",
        location: "mdi mdi-map-marker-outline"
      };
      return mapa[tipo] || null;
    },
    obtenerThumbMensajeDirecto(msg) {
      if (!msg) return null;
      const tipo = obtenerTipoMensaje(msg);
      if (tipo === "image") return obtenerMediaUrl(msg, "image");
      if (tipo === "video" || tipo === "gif") return obtenerMediaUrl(msg, "video");
      if (tipo === "sticker") return obtenerMediaUrl(msg, "sticker");
      return null;
    },
    iniciarRespuesta(msg) {
      if (!msg) return;
      this.mensajeCitadoParaResponder = msg;
      this.$nextTick(() => {
        this.$refs.inputMensaje?.focus();
      });
    },
    cancelarRespuesta() {
      this.mensajeCitadoParaResponder = null;
    },
    scrollAlMensaje(targetMsg) {
      if (!targetMsg) return;
      const targetId = obtenerWamid(targetMsg) || targetMsg.id;
      if (targetId) {
        const el = this.$el?.querySelector(`[data-msg-id="${targetId}"]`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.classList.add("wa-msg-highlight");
          setTimeout(() => el.classList.remove("wa-msg-highlight"), 1500);
        }
      }
    },

    // Selector de Emojis
    verificarClickAfueraEmoji(e) {
      if (!this.mostrarEmojis) return;
      if (this.$refs.emojiPickerRef && !this.$refs.emojiPickerRef.contains(e.target) && this.$refs.emojiBtnRef && !this.$refs.emojiBtnRef.contains(e.target)) {
        this.mostrarEmojis = false;
      }
    },
    toggleEmojis() {
      this.mostrarEmojis = !this.mostrarEmojis;
    },
    insertarEmoji(emoji) {
      this.mensajeActual = (this.mensajeActual || "") + emoji;
      this.ajustarAlturaTextarea();
      this.$nextTick(() => this.$refs.inputMensaje?.focus());
    },

    // Selección de archivos y envío
    triggerSeleccionarArchivo() {
      this.$refs.fileInputArchivo?.click();
    },
    alSeleccionarArchivo(e) {
      const file = e.target.files?.[0];
      if (!file) return;

      let tipo = "document";
      if (file.type.startsWith("image/")) tipo = "image";
      else if (file.type.startsWith("video/")) tipo = "video";
      else if (file.type.startsWith("audio/")) tipo = "audio";

      this.archivoSeleccionado = file;
      this.tipoArchivo = tipo;
      this.previewUrl = URL.createObjectURL(file);
      e.target.value = "";
    },
    limpiarArchivoSeleccionado() {
      if (this.previewUrl) {
        try {
          URL.revokeObjectURL(this.previewUrl);
        } catch (e) { }
      }
      this.archivoSeleccionado = null;
      this.tipoArchivo = "document";
      this.previewUrl = null;
    },
    enviar() {
      if (this.enviando || this.enviandoMensaje) return;
      if (this.listaMensajes.length === 0) return;
      if (!this.archivoSeleccionado && (!this.mensajeActual || !this.mensajeActual.trim())) return;

      this.enviando = true;
      const payload = {};
      if (this.archivoSeleccionado) {
        payload.tipo = this.tipoArchivo;
        payload.archivo = this.archivoSeleccionado;
        payload.caption = (this.mensajeActual || "").trim();
      } else {
        payload.mensaje = this.mensajeActual.trim();
        payload.tipo = "text";
      }

      if (this.mensajeCitadoParaResponder) {
        payload.id_mensaje_citado = this.mensajeCitadoParaResponder.id;
        payload.wamid_citado = obtenerWamid(this.mensajeCitadoParaResponder) || this.mensajeCitadoParaResponder.id;
        payload.es_saliente_citado = esSaliente(this.mensajeCitadoParaResponder, this.chatSeleccionado);
        payload.texto_citado = obtenerTextoMensaje(this.mensajeCitadoParaResponder);
        payload.tipo_citado = obtenerTipoMensaje(this.mensajeCitadoParaResponder);
      }

      this.$emit("enviar-mensaje", payload);
      this.mensajeCitadoParaResponder = null;
      this.urlDetectadaInput = null;
      this.previewUrlInput = null;
      clearTimeout(this.timerDebounceUrlInput);
      if (this.archivoSeleccionado) {
        this.limpiarArchivoSeleccionado();
      }
      this.mensajeActual = "";
      this.resetearAlturaTextarea();
      this.$nextTick(() => {
        this.scrollAlFinal();
        setTimeout(() => {
          this.enviando = false;
        }, 500);
      });
    },

    // Scroll y Lightbox
    onScrollConversacion(event) {
      const el = event?.target || (this.$refs.conversationScroll?.$el ? (this.$refs.conversationScroll.$el.querySelector(".simplebar-content-wrapper") || this.$refs.conversationScroll.$el) : null);
      if (!el) return;

      // Si el usuario llega cerca de arriba (top <= 40px) y no estamos cargando ya
      if (el.scrollTop <= 40 && !this.cargandoMasMensajes && !this.cargandoMensajes && !this.noHayMasMensajesHistoricos) {
        const alturaAnterior = el.scrollHeight;
        const scrollAnterior = el.scrollTop;

        this.$emit("cargar-mas-mensajes", () => {
          // Callback que se ejecuta tras renderizar los mensajes nuevos arriba
          this.$nextTick(() => {
            const nuevaAltura = el.scrollHeight;
            const diferencia = nuevaAltura - alturaAnterior;
            // Mantener la vista en el mismo mensaje que estaba viendo
            el.scrollTop = scrollAnterior + diferencia;
          });
        });
      }
    },
    scrollAlFinal(inmediato = false) {
      this.$nextTick(() => {
        setTimeout(() => {
          const contenedor = this.$refs.conversationScroll;
          if (contenedor?.$el) {
            const el = contenedor.$el.querySelector(".simplebar-content-wrapper") || contenedor.$el;
            if (inmediato) el.scrollTop = el.scrollHeight;
            else el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
          }
        }, 50);
      });
    },
    abrirLightbox(url) {
      if (!url) return;
      const imgs = [];
      this.listaMensajes.forEach((m) => {
        const u = obtenerMediaUrl(m, "image") || obtenerMediaUrl(m, "sticker") || obtenerPlantillaInfo(m)?.imagenUrl;
        if (u && !imgs.includes(u)) imgs.push(u);
      });
      if (!imgs.includes(url)) imgs.push(url);
      this.lightboxImgs = imgs;
      this.lightboxIndex = Math.max(0, imgs.indexOf(url));
      this.lightboxVisible = true;
    },

    // Respuestas Rápidas
    toggleMenuRespuestasRapidas() {
      this.menuRespuestasRapidasVisible = !this.menuRespuestasRapidasVisible;
      this.filtroRespuestasRapidas = "";
      if (this.menuRespuestasRapidasVisible) {
        this.$nextTick(() => this.$refs.inputMensaje?.focus());
      }
    },
    alEscribirMensaje() {
      this.ajustarAlturaTextarea();
      const texto = this.mensajeActual || "";
      if (texto.startsWith("/")) {
        this.menuRespuestasRapidasVisible = true;
        this.filtroRespuestasRapidas = texto.substring(1);
      } else {
        this.menuRespuestasRapidasVisible = false;
        this.filtroRespuestasRapidas = "";
      }

      // Detección de URL en tiempo real mientras escribe (con debounce)
      clearTimeout(this.timerDebounceUrlInput);
      const url = this.extraerPrimeraUrl(texto);
      if (!url) {
        this.urlDetectadaInput = null;
        this.previewUrlInput = null;
      } else if (url !== this.urlDetectadaInput) {
        this.urlDetectadaInput = url;
        this.timerDebounceUrlInput = setTimeout(() => {
          WhatsappSrv.previewUrl(url)
            .then((response) => {
              const data = response && response.data !== undefined ? response.data : response;
              if (data && (data.title || data.description || data.image)) {
                this.previewUrlInput = data;
                this.mapaUrlPreviews = { ...this.mapaUrlPreviews, [url]: data };
              }
            })
            .catch(() => { });
        }, 600);
      }
    },
    ajustarAlturaTextarea() {
      this.$nextTick(() => {
        const el = this.$refs.inputMensaje;
        if (!el) return;
        el.style.height = "auto";
        const nuevaAltura = Math.min(el.scrollHeight, 120);
        el.style.height = `${nuevaAltura}px`;
      });
    },
    resetearAlturaTextarea() {
      this.$nextTick(() => {
        const el = this.$refs.inputMensaje;
        if (!el) return;
        el.style.height = "auto";
      });
    },
    navegarRespuestasRapidas(delta) {
      if (!this.menuRespuestasRapidasVisible) return;
      this.$refs.cmpRespuestasRapidas?.moverSeleccion(delta);
    },
    alPresionarEnter(e) {
      if (this.menuRespuestasRapidasVisible) {
        const seleccionado = this.$refs.cmpRespuestasRapidas?.seleccionarActual();
        if (seleccionado) {
          e.preventDefault();
          return;
        }
      }
      this.enviar();
    },
    onRespuestaRapidaSeleccionada(textoProcesado) {
      this.mensajeActual = textoProcesado || "";
      this.ajustarAlturaTextarea();
      this.menuRespuestasRapidasVisible = false;
      this.filtroRespuestasRapidas = "";
      this.$nextTick(() => {
        this.$refs.inputMensaje?.focus();
      });
    },
    cerrarTodosDropdowns() {
      document.dispatchEvent(new MouseEvent("click", { bubbles: true, cancelable: true }));
    },
    accionBloquear(chat) {
      if (this.procesandoBloqueo) return;
      this.cerrarTodosDropdowns();
      this.$emit("bloquear-contacto", chat);
    },
    accionDesbloquear(chat) {
      if (this.procesandoBloqueo) return;
      this.cerrarTodosDropdowns();
      this.$emit("desbloquear-contacto", chat);
    }
  }
};
</script>
